export const VALIDATION = 'validation';
export const COMMON = 'common';
export const VENDOR = 'vendor';
export const VERIFIER = 'verifier';
export const ONBOARDING = 'onboarding';
export const DASHBOARD = 'dashboard';
export const TEAM_MEMBER_LOCALE_KEY = 'teamMembers';
export const ISSUING_AUTHORITY = 'issuingAuthority';
export const IA_VERIFIER = 'iaVerifier';
export const AVAILABLE_LANGUAGES = {
  en: 'en',
  ar: 'ar'
};

export const DEFAULT_LNG = AVAILABLE_LANGUAGES.en;
export const LANGUAGE_PREFERENCE_KEY = 'languagePreference';
export const LANGUAGES = [AVAILABLE_LANGUAGES.en, AVAILABLE_LANGUAGES.ar];
export const DEFAULT_NS = 'common';
export const COOKIE_NAME = 'portalLang';
export const SKIP_TASK_BUTTON = 'skipTaskButton';
